import { render, staticRenderFns } from "./AwardHistoryDialog.vue?vue&type=template&id=41f70438"
import script from "./AwardHistoryDialog.vue?vue&type=script&lang=js"
export * from "./AwardHistoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports